// extracted by mini-css-extract-plugin
export default {"dropdown":"SortingDropdown-module__dropdown--JZoZ2","option":"SortingDropdown-module__option--RVVIF"};